import React, {
  useEffect
} from 'react'

import { 
  Form,
  Input,
  InputNumber,
  Col, 
  Row,
  Divider,
  Checkbox,
  DatePicker,
} from 'antd';
import dayjs from 'dayjs';

const { Item } = Form;
const { TextArea } = Input;

const ProfileTab = (memberData) => {
  const [addForm] = Form.useForm();
  useEffect(() => {
    addForm.setFieldsValue({
      member_no: memberData?.memberData?.member_no || '',
      last_name: memberData?.memberData?.last_name || '',
      first_name: memberData?.memberData?.first_name || '',
      middle_name: memberData?.memberData?.middle_name || '',
      suffix: memberData?.memberData?.suffix || '',
      type: memberData?.memberData?.type || '',
      class: memberData?.memberData?.class || '',
      tin: memberData?.memberData?.tin || '',
      place_issued: memberData?.memberData?.place_issued || '',
      res_cert_no: memberData?.memberData?.res_cert_no || '',
      sellers_code: memberData?.memberData?.sellers_code || '',
      corporate_id: memberData?.memberData?.corporate_id || '',
      date_issued: memberData?.memberData?.date_issued ? dayjs(memberData?.memberData?.date_issued) : undefined,
      expiry_date: memberData?.memberData?.expiry_date ? dayjs(memberData?.memberData?.expiry_date) : undefined,
      assignor: memberData?.memberData?.assignor || '',
      credit_limit: memberData?.memberData?.credit_limit ?? null,
      remarks: memberData?.memberData?.remarks || '',
      title: memberData?.memberData?.title || '',
      is_st_lucia: memberData?.memberData?.is_st_lucia === "1" ? true : false,
      gender: memberData?.memberData?.gender || '',
      civil_status: memberData?.memberData?.civil_status || '',
      nationality: memberData?.memberData?.nationality || '',
      birthdate: memberData?.memberData?.birthdate ? dayjs(memberData?.memberData?.birthdate) : undefined,
      place_of_birth: memberData?.memberData?.place_of_birth || '',
      voting_member: memberData?.memberData?.voting_member || '',
      ar_cust_id: memberData?.memberData?.ar_cust_id || '',
      certificate_no: memberData?.memberData?.certificate_no || '',
      insurance: memberData?.memberData?.insurance || '',
      other_expiry_date: memberData?.memberData?.other_expiry_date ? dayjs(memberData?.memberData?.other_expiry_date) : undefined,
      approved_by: memberData?.memberData?.approved_by || '',
      date: memberData?.memberData?.date ? dayjs(memberData?.memberData?.date) : undefined,
      category: memberData?.memberData?.category || '',
      sc_pwd_id: memberData?.memberData?.sc_pwd_id || '',
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberData]);
  return (
    <Row className='tab-container custom-padding'>
      <Col span={24}>
        <Form 
          layout="vertical"
          form={addForm} 
        >
          <Row>
            <Col 
              xs={24} sm={24} md={15} lg={6} xl={6}
              className='p-2'
            >
              <Item
                label="TIN Number"
                name="tin"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
              >
                <Input disabled/>
              </Item>
            </Col>
            <Col 
              xs={24} sm={24} md={15} lg={6} xl={6}
              className='p-2'
            >
              <Item
                label="Place Issued"
                name="place_issued"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Name!' }]}
              >
                <Input disabled/>
              </Item>
            </Col>
            <Col 
              xs={24} sm={24} md={15} lg={6} xl={6}
              className='p-2'
            >
              <Item
                label="Date Issued"
                name="date_issued"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Name!' }]}
              >
                <DatePicker disabled style={{width:'100%'}} format="YYYY-MM-DD"/>
              </Item>
            </Col>
            <Col 
              xs={24} sm={24} md={15} lg={6} xl={6}
              className='p-2'
            >
              <Item
                label="Expiry Date"
                name="expiry_date"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Name!' }]}
              >
                <DatePicker disabled style={{width:'100%'}} format="YYYY-MM-DD"/>
              </Item>
            </Col>
          </Row>
          <Row>
            <Col 
              xs={24} sm={24} md={24} lg={12} xl={12}
              className='p-2'
            >
              <Item
                label="Res Cert No."
                name="res_cert_no"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
              >
                <Input disabled/>
              </Item>
            </Col>
            <Col 
              xs={24} sm={24} md={24} lg={12} xl={12}
              className='p-2'
            >
              <Item
                label="Assignor"
                name="assignor"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Name!' }]}
              >
                <Input disabled/>
              </Item>
            </Col>
            <Col xs={24} lg={12} className='p-2'>
              <Item label="Credit Limit" name="credit_limit" className='p-0 m-0'>
                <InputNumber className='member-credit-limit-input' precision={2} controls={false} disabled />
              </Item>
            </Col>
          </Row>
          <Row>
            <Col span={24} className='p-2'>
              <Item
                label="Remarks"
                name="remarks"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
              >
                <TextArea disabled rows={4}/>
              </Item>
            </Col>
          </Row>
          <Divider className='divider-text'>Others</Divider>
          <Row>
            <Col 
              xs={24} sm={24} md={24} lg={12} xl={12}
              className='p-2'
            >
              <Item
                label="Title"
                name="title"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
              >
                <Input disabled/>
              </Item>
            </Col>
            <Col 
              xs={24} sm={24} md={15} lg={6} xl={6}
              className='p-2'
            >
              <Item
                  label="Senior Citizen / PWD"
                  name="sc_pwd_id"
                  className='p-0 m-0'
                  // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
              >
                  <Input disabled/>
              </Item>
            </Col>
            <Col 
              xs={24} sm={24} md={15} lg={6} xl={6}
              className='p-2'
            >
              <Item
                label="St. Lucia"
                name="is_st_lucia"
                className='p-0 m-0'
                valuePropName="checked"
                // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
              >
                <Checkbox disabled>No</Checkbox>
              </Item>
            </Col>
          </Row>
          <Row>
            <Col 
              xs={24} sm={24} md={15} lg={6} xl={6}
              className='p-2'
            >
              <Item
                label="Place of Birth"
                name="place_of_birth"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
              >
                <Input disabled/>
              </Item>
            </Col>
            <Col 
              xs={24} sm={24} md={15} lg={6} xl={6}
              className='p-2'
            >
              <Item
                label="Voting Member"
                name="voting_member"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Name!' }]}
              >
                <Input disabled/>
              </Item>
            </Col>
            <Col 
              xs={24} sm={24} md={15} lg={6} xl={6}
              className='p-2'
            >
              <Item
                label="Corporate ID"
                name="corporate_id"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
              >
                <Input disabled/>
              </Item>
            </Col>
            <Col 
              xs={24} sm={24} md={15} lg={6} xl={6}
              className='p-2'
            >
              <Item
                label="Certificate Number"
                name="certificate_no"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Name!' }]}
              >
                <Input disabled/>
              </Item>
            </Col>
          </Row>
          <Row>
            <Col 
              xs={24} sm={24} md={24} lg={12} xl={12}
              className='p-2'
            >
              <Item
                label="Insurance"
                name="insurance"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
              >
                <Input disabled/>
              </Item>
            </Col>
            <Col 
              xs={24} sm={24} md={24} lg={12} xl={12}
              className='p-2'
            >
              <Item
                label="Expiry Date"
                name="other_expiry_date"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
              >
                <DatePicker disabled style={{width:'100%'}} format="YYYY-MM-DD"/>
              </Item>
            </Col>
          </Row>
          <Row>
            <Col 
              xs={24} sm={24} md={24} lg={12} xl={12}
              className='p-2'
            >
              <Item
                label="Approved By"
                name="approved_by"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
              >
                <Input disabled/>
              </Item>
            </Col>
            <Col 
              xs={24} sm={24} md={24} lg={12} xl={12}
              className='p-2'
            >
              <Item
                label="Date"
                name="date"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
              >
                <DatePicker disabled style={{width:'100%'}} format="YYYY-MM-DD"/>
              </Item>
            </Col>
          </Row>
          <Row>
            <Col 
              xs={24} sm={24} md={24} lg={12} xl={12}
              className='p-2'
            >
              <Item
                label="Category"
                name="category"
                className='p-0 m-0'
                // rules={[{ required: true, message: 'Please enter your Member ID!' }]}
              >
                <Input disabled/>
              </Item>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  )
}
export default ProfileTab
